import { ProductPageStore } from '../store/product-page-store';
import WordPressAjaxService from './wordpress-ajax-service';
export default class ReviewsService {
    constructor() {
        var _a;
        this.container = document.querySelector('.reviews-block');
        this.list = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.reviews-block-list');
    }
    initShowMoreButtons() {
        if (!this.container) {
            return;
        }
        this.container.ownerDocument.addEventListener('click', (event) => {
            const target = event.target;
            const showMoreContainer = target.closest('.review-data-show-more');
            if (!showMoreContainer) {
                return;
            }
            const parent = showMoreContainer.closest('.review-data');
            if (!parent) {
                return;
            }
            parent.classList.toggle('short');
        });
    }
    initLikeButtons() {
        if (!this.container) {
            return;
        }
        this.container.ownerDocument.addEventListener('click', (event) => {
            const target = event.target;
            const comment = target.closest('.review');
            const likeBtn = target.closest('.like-icon');
            const dislikeBtn = target.closest('.dislike-icon');
            if (!likeBtn && !dislikeBtn) {
                return;
            }
            const action = likeBtn ? 'like' : 'dislike';
            ProductPageStore.getState()
                .rateReview(comment.dataset.commentId, action)
                .then((data) => {
                const [likesEl, dislikesEl] = comment.querySelectorAll('.review-likes-counts span');
                if (likesEl && typeof data.likes !== 'undefined') {
                    likesEl.innerHTML = data.likes;
                    likeBtn.classList.toggle('pressed');
                }
                if (dislikesEl && typeof data.dislikes !== 'undefined') {
                    dislikesEl.innerHTML = data.dislikes;
                    dislikeBtn.classList.toggle('pressed');
                }
            });
        });
    }
    initLoadMoreButtons() {
        if (!this.container) {
            return;
        }
        this.loadMoreBtn = this.container.querySelector('.reviews-load-more');
        if (!this.loadMoreBtn) {
            return;
        }
        this.loadMoreBtn.addEventListener('click', (event) => {
            ProductPageStore.getState().loadComments();
        });
    }
    getPostIdFromBodyClass() {
        const body = document === null || document === void 0 ? void 0 : document.body;
        const match = body.className.match(/postid-(\d+)/);
        return match ? parseInt(match[1], 10) : null;
    }
    getCommentsPostIdOnReviewsPage() {
        var _a;
        const body = document === null || document === void 0 ? void 0 : document.body;
        const input = body.querySelector(`input[name="product_id"]`);
        return parseInt((_a = input === null || input === void 0 ? void 0 : input.value) !== null && _a !== void 0 ? _a : '0', 10);
    }
    initReviewsStore() {
        var _a;
        ProductPageStore.getState().setPostId(Number((_a = this.getPostIdFromBodyClass()) !== null && _a !== void 0 ? _a : this.getCommentsPostIdOnReviewsPage()));
        ProductPageStore.getState().setApi(new WordPressAjaxService(window.perlaData.ajax_url, window.perlaData.productPageNonce));
        ProductPageStore.subscribe((state, prevState) => {
            var _a, _b, _c, _d, _e, _f;
            if (state.isLoading) {
                (_a = this.loadMoreBtn) === null || _a === void 0 ? void 0 : _a.classList.add('loading');
            }
            else {
                (_b = this.loadMoreBtn) === null || _b === void 0 ? void 0 : _b.classList.remove('loading');
            }
            if (state.hasMore) {
                if (!((_c = this.loadMoreBtn) === null || _c === void 0 ? void 0 : _c.classList.contains('has-more'))) {
                    (_d = this.loadMoreBtn) === null || _d === void 0 ? void 0 : _d.classList.add('has-more');
                }
            }
            else {
                (_e = this.loadMoreBtn) === null || _e === void 0 ? void 0 : _e.classList.remove('has-more');
            }
            if (this.list && state.comments && state.comments !== prevState.comments) {
                const parser = new DOMParser();
                (_f = this.list) === null || _f === void 0 ? void 0 : _f.append(...parser.parseFromString(state.comments, 'text/html').body.children);
            }
        });
    }
    initAddReviewModal() {
        const modal = document.querySelector('.modal-add-review');
        const starsWrapper = modal === null || modal === void 0 ? void 0 : modal.querySelector('.stars-wrapper');
        const stars = starsWrapper === null || starsWrapper === void 0 ? void 0 : starsWrapper.querySelectorAll('.star-icon');
        const ratingText = modal === null || modal === void 0 ? void 0 : modal.querySelector('.rating-score-text .score-value');
        const ratingInput = modal === null || modal === void 0 ? void 0 : modal.querySelector('#add_review_rating');
        if (!starsWrapper || !stars || !ratingText) {
            return;
        }
        let selectedRating = 0;
        function updateStars(rating) {
            selectedRating = rating;
            if (ratingInput) {
                ratingInput.value = rating;
            }
            ratingText.textContent = `${rating} / 5`;
            if (!stars) {
                return;
            }
            stars.forEach((star, i) => {
                star.classList.remove('empty', 'half', 'full');
                if (i + 1 <= rating) {
                    star.classList.add('full');
                }
                else {
                    star.classList.add('empty');
                }
            });
        }
        stars.forEach((star, index) => {
            star.addEventListener('click', () => {
                selectedRating = index + 1;
                updateStars(selectedRating);
            });
        });
        starsWrapper.addEventListener('touchmove', (e) => {
            const touch = e.touches[0];
            const element = document.elementFromPoint(touch.clientX, touch.clientY);
            if (element && element.classList.contains('star-icon')) {
                const index = [...stars].indexOf(element);
                if (index !== -1) {
                    updateStars(index + 1);
                }
            }
        });
        stars.forEach((star, index) => {
            star.addEventListener('mouseover', () => updateStars(index + 1));
            starsWrapper.addEventListener('mouseleave', () => updateStars(selectedRating));
        });
        this.initFileUploadImage();
    }
    initFileUploadImage() {
        const modal = document.querySelector('.modal-add-review');
        const fileInput = modal === null || modal === void 0 ? void 0 : modal.querySelector('input[type="file"]');
        const previewContainer = modal === null || modal === void 0 ? void 0 : modal.querySelector('.preview-container');
        if (!modal || !fileInput || !previewContainer) {
            return;
        }
        function handleFileSelect(event) {
            if (!previewContainer)
                return;
            const target = event.target;
            if (!target.files)
                return;
            const { files } = target;
            previewContainer.innerHTML = '';
            Array.from(files).forEach((file, index) => {
                if (!file.type.startsWith('image/'))
                    return;
                const reader = new FileReader();
                reader.onload = (e) => {
                    if (!e.target || !e.target.result)
                        return;
                    const preview = document.createElement('div');
                    preview.classList.add('preview');
                    preview.innerHTML = `
                    <img src="${e.target.result}" alt="Preview">
                    <span class="remove-btn" data-index="${index}"></span>
                `;
                    previewContainer.appendChild(preview);
                };
                reader.readAsDataURL(file);
            });
        }
        fileInput.addEventListener('change', handleFileSelect);
        previewContainer.addEventListener('click', function (event) {
            var _a;
            const target = event.target;
            if (target.classList.contains('remove-btn')) {
                (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.remove();
            }
        });
    }
    initProductPageDropdown() {
        var _a;
        try {
            const dropdown = document.querySelector('.custom-dropdown');
            if (!dropdown)
                return;
            const toggle = dropdown.querySelector('.dropdown-toggle');
            const menu = dropdown.querySelector('.dropdown-menu');
            const input = document.getElementById('dropdown-input');
            const form = document.getElementById('product-form');
            toggle === null || toggle === void 0 ? void 0 : toggle.addEventListener('click', () => {
                dropdown.classList.toggle('open');
            });
            menu === null || menu === void 0 ? void 0 : menu.addEventListener('click', (event) => {
                var _a;
                const target = event.target;
                if (target && (target === null || target === void 0 ? void 0 : target.classList.contains('dropdown-item'))) {
                    const selectedValue = target.getAttribute('data-value');
                    if (toggle) {
                        toggle.innerHTML = `${(_a = target.innerText) !== null && _a !== void 0 ? _a : ''} <span class="dropdown-arrow">▼</span>`;
                    }
                    if (input && form) {
                        input.value = selectedValue !== null && selectedValue !== void 0 ? selectedValue : '';
                        form.submit();
                    }
                }
            });
            (_a = document.querySelector('.reviews-block')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (event) => {
                const target = event.target;
                if (!dropdown.contains(target)) {
                    dropdown.classList.remove('open');
                }
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    init() {
        this.initProductPageDropdown();
        this.initReviewsStore();
        this.initShowMoreButtons();
        this.initLoadMoreButtons();
        this.initLikeButtons();
        this.initAddReviewModal();
    }
}
